import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/api";

/**
 * Get all submissions
 * @returns Promise with all submissions
 */
export const getAllSubmissions = async () => {
  try {
    const response = await axios.get(`${API_URL}/submissions`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all submissions:", error);
    throw error;
  }
};

/**
 * Get a submission by ID
 * @param id - The ID of the submission
 * @returns Promise with the submission data
 */
export const getSubmissionById = async (id: string) => {
  try {
    const response = await axios.get(`${API_URL}/submissions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching submission with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Get three random submissions for a question
 * @param questionId - The ID of the question
 * @returns Promise with three random submissions
 */
export const getThreeRandomSubmissionsForQuestion = async (
  questionId: string
) => {
  try {
    const response = await axios.get(
      `${API_URL}/submissions/question/${questionId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching random submissions for question ${questionId}:`,
      error
    );
    throw error;
  }
};

/**
 * Create a new submission
 * @param submissionData - The submission data
 * @returns Promise with the created submission
 */
export const createSubmission = async (submissionData: any) => {
  try {
    const response = await axios.post(`${API_URL}/submissions`, submissionData);
    return response.data;
  } catch (error) {
    console.error("Error creating submission:", error);
    throw error;
  }
};

/**
 * Update a submission
 * @param id - The ID of the submission to update
 * @param submissionData - The updated submission data
 * @returns Promise with the updated submission
 */
export const updateSubmission = async (id: string, submissionData: any) => {
  try {
    const response = await axios.put(
      `${API_URL}/submissions/${id}`,
      submissionData
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating submission with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Delete a submission
 * @param id - The ID of the submission to delete
 * @returns Promise with the deletion result
 */
export const deleteSubmission = async (id: string) => {
  try {
    const response = await axios.delete(`${API_URL}/submissions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting submission with ID ${id}:`, error);
    throw error;
  }
};
